var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "54",
        height: "40",
        viewBox: "0 0 54 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: { width: "54", height: "40", rx: "20", fill: "#EDF2F5" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M33.75 26.75L30.4875 23.4875M26.25 17V21.5M24 19.25H28.5M32.25 19.25C32.25 22.5637 29.5637 25.25 26.25 25.25C22.9363 25.25 20.25 22.5637 20.25 19.25C20.25 15.9363 22.9363 13.25 26.25 13.25C29.5637 13.25 32.25 15.9363 32.25 19.25Z",
          stroke: "#002436",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }